import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";

export class CreateInvoiceApiRequest {
  sttNumbers: string[] = [];
  billedTo = "";
  billedToName = "";
  billedToPhone = "";
  note = "";

  constructor(fields?: Partial<CreateInvoiceApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    const { billedTo, ...payload } = this;
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(payload));
  }
}

export type SendToVia = "email" | "phone";
export type SendToFormat = "pdf_a4" | "pdf_struk" | "png_a4";

export interface BilledTo {
  name: string;
  phone: string;
  email?: string;
  address?: string;
}

export interface SendTo {
  via: SendToVia;
  email?: string;
  phone?: string;
  format: SendToFormat;
}

export class CreateInvoiceDetailBillApiRequest {
  stts: string[] = [];
  note = "";
  billedTo: BilledTo = {
    name: "",
    phone: "",
  };
  sendTo?: SendTo[];
  
  constructor(fields?: Partial<CreateInvoiceDetailBillApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}


export class ListBookingHistoryDetailApiRequest {
  sttNumbers: string[] = [];

  constructor(fields?: Partial<ListBookingHistoryDetailApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

/* eslint-disable @typescript-eslint/camelcase */
export class SettlementInvoiceRequest {
  amount: number;

  constructor(amount: number) {
    this.amount = amount;
  }

  toJSON(): string {
    return JSON.stringify({
      amount: this.amount
    });
  }
}

export class DraftPreviewForUpdateRequest {
  private customerId: number;
  private customerType: any;
  private customerName: string;
  private customerPhone: string;
  private bookingDateFrom: string;
  private bookingDateTo: string;
  private sttTypes?: Array<any>;
  private serviceTypes?: Array<any>;
  private additionalStt?: Array<any>;

  constructor(
    customerId: number,
    customerType: any,
    customerName: string,
    customerPhone: string,
    bookingDateFrom: string,
    bookingDateTo: string,
    sttTypes: Array<any>,
    serviceTypes: Array<any>,
    additionalStt: Array<any>
  ) {
    this.customerId = customerId;
    this.customerType = customerType;
    this.customerName = customerName;
    this.customerPhone = customerPhone;
    this.bookingDateFrom = bookingDateFrom;
    this.bookingDateTo = bookingDateTo;
    this.sttTypes = sttTypes;
    this.serviceTypes = serviceTypes;
    this.additionalStt = additionalStt;
  }
  public toJSON(): string {
    return JSON.stringify({
      customer_id: this.customerId,
      customer_type: this.customerType,
      customer_name: this.customerName,
      customer_phone: this.customerPhone,
      booking_date_from: this.bookingDateFrom,
      booking_date_to: this.bookingDateTo,
      stt_types: this.sttTypes,
      service_types: this.serviceTypes,
      additional_stt: this.additionalStt
    });
  }
}

export class UpdateInvoiceRequest {
  private sttNumbers: Array<string>;
  private billedTo: string;
  private billedToName: string;
  private billedToPhone: string;
  private note: string;

  constructor(
    sttNumbers: Array<string>,
    billedTo: string,
    billedToName: string,
    billedToPhone: string,
    note: string
  ) {
    this.sttNumbers = sttNumbers;
    this.billedTo = billedTo;
    this.billedToName = billedToName;
    this.billedToPhone = billedToPhone;
    this.note = note;
  }
  public toJSON(): string {
    return JSON.stringify({
      stt_numbers: this.sttNumbers,
      billed_to: this.billedTo,
      billed_to_name: this.billedToName,
      billed_to_phone: this.billedToPhone,
      note: this.note
    });
  }
}

export class ActivityRequest {
  private printed: boolean;

  constructor(printed: boolean) {
    this.printed = printed;
  }
  public toJSON(): string {
    return JSON.stringify({
      printed: this.printed
    });
  }
}
